module.exports = __webpack_public_path__ + "static/media/getFetch.51c934af.cjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/i18next-http-backend/esm/getFetch.cjs
// module id = 215
// module chunks = 0